import { render, staticRenderFns } from "./QuickCreate.vue?vue&type=template&id=3eb98e1d&scoped=true&"
import script from "./QuickCreate.vue?vue&type=script&lang=js&"
export * from "./QuickCreate.vue?vue&type=script&lang=js&"
import style0 from "./QuickCreate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./QuickCreate.vue?vue&type=style&index=1&id=3eb98e1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb98e1d",
  null
  
)

export default component.exports